import { BuildingIcon, XCloseIcon } from '@newcore/icons';
import { Button } from '@newcore/ui/buttons';
import { Sizes } from '@newcore/ui/enums/sizes';
import { ButtonVariants } from '@newcore/ui/enums/variants';

interface RememberedTenantTilesProps {
  tenants: string[];
  isDisabled: boolean;
  onSelect: (tenant: string) => void;
  onRemove: (tenant: string) => void;
}

export function RememberedTenantTiles({
  tenants,
  isDisabled,
  onSelect,
  onRemove,
}: RememberedTenantTilesProps) {
  return (
    <ul className='space-y-2' data-testid='remembered-tenant-tiles'>
      {tenants.map(tenant => (
        <li key={tenant} className='flex items-center gap-2'>
          <Button
            variant={ButtonVariants.SECONDARY}
            size={Sizes.XL}
            iconLeading={BuildingIcon}
            disabled={isDisabled}
            onClick={() => onSelect(tenant)}
            className='flex-1 justify-start'
            data-testid='remembered-tenant-tile'
          >
            {tenant}
          </Button>
          <Button
            variant={ButtonVariants.ICON}
            iconLeading={XCloseIcon}
            disabled={isDisabled}
            onClick={() => onRemove(tenant)}
            aria-label={`Remove ${tenant}`}
            data-testid='remembered-tenant-remove'
          />
        </li>
      ))}
    </ul>
  );
}
